import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, switchMap, from, of } from 'rxjs';
import * as FilterScopedLogbookActions from './scoped-logbook.actions';
import { HelperService } from '../../../shared/service/helper.service';
import { ScopedLogbookService } from '../../../shared/service/filter/scoped-logbook.service';
import {
  IScopedLogbookDropdownData,
  IScopedLogbookDropdownResponse,
} from '../../../shared/component/filter/filter.class';

@Injectable()
export class FilterScopedLogbookEffects {
  constructor(
    private readonly actions$: Actions<FilterScopedLogbookActions.FilterScopedLogbookActions>,
    public service: ScopedLogbookService,
    public helperService: HelperService,
  ) {}

  getScopedLogbooksEffect = createEffect(() =>
    this.actions$.pipe(
      ofType(FilterScopedLogbookActions.GET_SCOPED_LOGBOOKS_FILTER),
      switchMap((objectData: FilterScopedLogbookActions.GetScopedLogbooks) => {
        return from(this.service.getScopedLogbooks()).pipe(
          switchMap((response: IScopedLogbookDropdownResponse[]) => {
            return of(
              new FilterScopedLogbookActions.GetScopedLogbooksCompleted(
                response.map((rowData: IScopedLogbookDropdownResponse): IScopedLogbookDropdownData => {
                  return {
                    ...rowData,
                    id: rowData.logbookTableId,
                    name: this.helperService.getNameWithArchiveLabel(
                      rowData.logbookIsArchived,
                      `${rowData.logbookId} - ${rowData.logbookVersionName}`,
                    ),
                  };
                }),
              ),
            );
          }),
          catchError(() => {
            return of(new FilterScopedLogbookActions.GetScopedLogbooksCompleted([]));
          }),
        );
      }),
    ),
  );
}
